import type { IconName } from '@core/user-interface-legacy';

import type { DowngradeViewTextsI } from './product-order-downgrade.types';

export const DowngradeView2024Texts: DowngradeViewTextsI = {
  accordionHeading: 'app.pricing.product_order.downgrade_2024.what_happens_to_the_grow',
  trialConfirmCheckbox: 'app.pricing.product_order.downgrade_2024.trial_confirm_start',
  features: [
    {
      title: 'app.pricing.product_order.downgrade.missing_features.custom_careers_url',
      link: 'app.support_resources.custom_domain',
    },
    {
      title: 'app.pricing.product_order.downgrade_2024.missing_features.event_scheduler',
      description: 'app.pricing.product_order.downgrade.missing_features_descriptions.scheduler',
      link: 'app.support_resources.schedule_events',
    },
    {
      title: 'app.pricing.product_order.downgrade.missing_features.multilang',
      link: 'app.support_resources.multilang',
    },
    {
      title: 'app.pricing.product_order.downgrade.missing_features.knockout_questions',
      link: 'app.support_resources.knockout_questions',
    },
    {
      title: 'app.pricing.product_order.downgrade.missing_features.templates',
      description:
        'app.pricing.product_order.downgrade_2024.missing_features_descriptions.templates',
      link: 'app.support_resources.workflow_templates_collection',
    },
    {
      title: 'app.pricing.product_order.downgrade.missing_features.advanced_reports',
      link: 'app.support_resources.reports_and_analysis',
    },
    {
      title: 'app.pricing.product_order.downgrade.missing_features.careers_hub_multi_page',
      link: 'app.support_resources.multipage',
    },
    {
      title: 'app.pricing.product_order.downgrade.missing_features.locations',
      link: 'app.support_resources.manage_locations',
    },
  ],
  downgradedFeaturesLeft: [
    {
      icon: 'dashboard',
      title: 'app.pricing.product_order.downgrade.features_info.templates.title',
      description: 'app.pricing.product_order.downgrade_2024.features_info.templates.description',
    },
    {
      icon: 'block',
      title: 'app.pricing.product_order.downgrade.features_info.knockout_questions.title',
      description:
        'app.pricing.product_order.downgrade.features_info.knockout_questions.description',
    },
    {
      icon: 'location-city',
      title: 'app.pricing.product_order.downgrade.features_info.multilang.title',
      description: 'app.pricing.product_order.downgrade_2024.features_info.multilang.description',
    },
  ],
  downgradedFeaturesRight: [
    {
      icon: <IconName>'link',
      title: 'app.pricing.product_order.downgrade.features_info.custom_domain.title',
      description: 'app.pricing.product_order.downgrade.features_info.custom_domain.description',
      hideOnTrial: true,
    },
    {
      icon: 'library-add',
      title: 'app.pricing.product_order.downgrade.features_info.careers_hub_multi_page.title',
      description:
        'app.pricing.product_order.downgrade_2024.features_info.careers_hub_multi_page.description',
    },
  ],
  heading: 'app.pricing.product_order.downgrade_2024.missing_features_heading',
  headingTrial: 'app.pricing.product_order.downgrade_2024.missing_features_heading',
  subheading: 'app.pricing.product_order.downgrade_2024.missing_features_subheading',
  subheadingTrial: 'app.pricing.product_order.downgrade_2024.missing_features_subheading_trial',
  header: 'app.pricing.product_order.downgrade_2024.title_downgrade_to_start',
  headerTrial: 'app.pricing.product_order.downgrade_2024.title_current_is_grow',
};
